import styled from 'styled-components';
import { pxToRem } from '../spacing';
import { themeGet } from '../theme';
const IconWrapper = styled.div `
  ${({ $size }) => $size && `--falcon-size: ${pxToRem($size)};`}
  ${({ $color }) => $color && `--falcon-color: ${themeGet(`colors.${$color}`)};`}
`;
export function createFalcon(component) {
    return function IconComponent(props) {
        const { size, color } = props;
        return (<IconWrapper $size={size} $color={color}>
        {component}
      </IconWrapper>);
    };
}
